import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation, FreeMode, Pagination } from 'swiper/modules';

const Testimonial = () => {
 const clients = [
  {
    label: 'Emily Carter (USA)',
    rev: 'Incredible experience! They built our website and mobile app with flawless UI and great performance. Professional, fast, and creative!',
    rating: 5
  },
  {
    label: 'Liam O’Connor (UK)',
    rev: 'Brilliant design work and marketing strategy. Our traffic and conversions increased within weeks. Highly recommended!',
    rating: 5
  },
  {
    label: 'Sofia Larsson (Sweden)',
    rev: 'The team created a beautiful brand identity for us. Very responsive and detail-oriented. Would definitely work with them again.',
    rating: 4
  },
  {
    label: 'Mark Fischer (Germany)',
    rev: 'Great app development skills. The final product was smooth, scalable, and exactly what we needed.',
    rating: 5
  },
  {
    label: 'Ava Thompson (Canada)',
    rev: 'Excellent communication and on-time delivery. They handled our full digital marketing campaign and exceeded expectations.',
    rating: 5
  },
  {
    label: 'James Wilson (USA)',
    rev: 'Superb website redesign. Our bounce rate dropped, and engagement is up. Highly skilled and professional team!',
    rating: 3
  },
  {
    label: 'Chloe Bennett (UK)',
    rev: 'From logos to landing pages, everything was top-notch. They truly understand branding and user experience.',
    rating: 5
  }
];


  // Function to render stars based on rating
  const renderStars = (rating) => {
    const fullStars = Array.from({ length: rating }, (_, index) => <svg key={index} className="w-4 h-4 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>);
    const emptyStars = Array.from({ length: 5 - rating }, (_, index) => <svg key={index} className="w-4 h-4 text-gray-100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>);
    
    return [...fullStars, ...emptyStars];
  };

  return (
    <>
      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        navigation={true}
        modules={[FreeMode, Navigation, Pagination]}
        freeMode={true}
        autoplay={true}
        pagination={{ clickable: true }}
        className="swiper-container max-w-[900px]"
        style={{ position: 'relative' }}
      >
        {clients.map((client, index) => (
          <SwiperSlide key={index}>
            <div className="w-full flex justify-center items-center">
              <section className="bg-gray-50">
                <div className="max-w-screen-xl px-4 py-8 mx-auto text-center lg:py-24 lg:px-6">
                  <figure className="max-w-screen-md mx-auto">
                    <svg
                      className="h-12 mx-auto mb-3 text-gray-400"
                      viewBox="0 0 24 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <blockquote>
                      <p className="text-xl font-medium text-gray-900 md:text-2xl">
                        "{client.rev}"
                      </p>
                    </blockquote>

                    {/* Star Rating */}
                   

                    <figcaption className="flex items-center justify-center mt-2 space-x-3">
                      <div className="flex items-center divide-x-2 divide-gray-500 ">
                        <div className="pr-3 font-medium text-gray-900">{client.label}</div>
                        <div class="bg-[#1353fe] p-2 rounded-full text-sm font-light text-gray-500 ">
                        <div className="flex justify-center">
                      {renderStars(client.rating)}
                    </div>
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </section>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Button Styles */}
      <style jsx>{`
        .swiper-button-next, .swiper-button-prev {
          background-color: #1353FE;
          color: white;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .swiper-button-next:after, .swiper-button-prev:after {
          font-size: 20px;
          color: white;
        }

        .swiper-pagination {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin: auto;
          position: initial;
          height: 18px;
          margin-top: 10px;
        }

        .swiper-pagination-bullet {
          background-color: #1353FE;
          width: 12px;
          height: 12px;
          border-radius: 50%;
        }

        .swiper-pagination-bullet-active {
          background-color: #1353FE;
        }
      `}</style>
    </>
  );
};

export default Testimonial;
